// For WASM build, we don't include the prebuilt version of Yoga but let the
// user specify the module manually with e.g.:
// https://github.com/shuding/yoga-wasm-web.
export async function getYogaModule() {
  return {}
}
